export default "__VITE_ASSET__Wr5nY9Mn__"